<template>
	<div v-if="user">
		<router-view
			v-if="user.hasRole(['manager', 'admin'])"
			:user="user"
			:isAuth="isAuth">
		</router-view>
	</div>
</template>

<script>
	export default {
		props: ['user', 'isAuth'],
		data () {
			return {
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/invoices/layout/Invoices.vue